import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

import {
  FetchPlannerBlockMetadata,
  FetchPlannerModeItems,
  ResetTable,
  getBaseScenario,
  getPlannerBlock,
  getPlannerBlockMetadataBlockId,
  getPlannerBlockMetadataScenarioId,
  getPlannerModel,
  getToolbarType,
} from 'redux/PlannerModeSlice';

// import BuilderModeDataTable from './DataTable';
import BuilderModePropertyTableOpz from './PropertyTableOpz';
import MapTab from './MapTab';
import BuilderModePropertyTableMetadata from './propertyTableMetadata';
import ModernDataTable from './ModernDataTable';

const monthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

const BuilderModeTable = ({ flags }: any) => {
  const { blockId } = useParams();
  const toolbarType = useSelector(getToolbarType);
  const plannerBlock: any = useSelector(getPlannerBlock);
  const modelDetails = useSelector(getPlannerModel);
  const baseScenario = useSelector(getBaseScenario);
  const blockMetadataScenarioId = useSelector(getPlannerBlockMetadataScenarioId);
  const blockMetadataBlockId = useSelector(getPlannerBlockMetadataBlockId);
  const dispatch: any = useDispatch();

  useEffect(() => {
    if (
      !baseScenario?.id ||
      !blockId ||
      !flags?.builderModeTable ||
      (toolbarType !== 'Data' && toolbarType !== 'Property')
    ) {
      return;
    }

    const metadataAlreadyLoadedForBlock =
      blockMetadataScenarioId === baseScenario.id && blockMetadataBlockId === Number(blockId);
    if (metadataAlreadyLoadedForBlock) return;

    dispatch(
      FetchPlannerBlockMetadata({
        blockId: Number(blockId),
        parameters: { scenario_id: baseScenario.id },
      }),
    );
  }, [
    baseScenario?.id,
    blockId,
    blockMetadataScenarioId,
    blockMetadataBlockId,
    toolbarType,
    flags?.builderModeTable,
  ]);

  useEffect(() => {
    const getIntialData = async () => {
      const startDateObject = new Date(baseScenario?.start_date);
      startDateObject.setMonth(startDateObject.getMonth() - 1);
      const yearFormat = `FY${startDateObject.getFullYear().toString().slice(-2)}`;
      const monthFormat = `${monthNames[startDateObject.getMonth()]}-${String(yearFormat).slice(
        -2,
      )}`;

      // if (plannerBlock?.indicators?.length) {
      //   const idArray = plannerBlock?.dimensions
      //     .filter((item: any) => item.name !== 'Time')
      //     .map((item: any) => item.id);
      //   const dimensionIds = idArray.join(', ');
      //   const payload = {
      //     blockId,
      //     params: {
      //       dim_id: dimensionIds,
      //       indicator_filter: 'all',
      //       scenario_id: baseScenario?.id,
      //     },
      //   };
      //   dispatch(FetchBlockOutputs(payload));
      // }

      const dimId = plannerBlock?.dimensions?.find((data: any) => {
        return data?.name === 'Time';
      });

      dispatch(
        FetchPlannerModeItems({
          dimensionId: dimId?.id,
          params: { scenario_id: baseScenario?.id },
          actuals:
            modelDetails?.time_properties?.time_granularity.toLowerCase() === 'm'
              ? monthFormat
              : yearFormat,
        }),
      );
    };
    getIntialData();
  }, [baseScenario]);

  useEffect(() => {
    return () => {
      dispatch(ResetTable());
    };
  }, []);

  if (toolbarType === 'Data') {
    // Adding an indicator is handled by CategoryTabsBar's "Add New Indicator"
    // button, so the grid doesn't need its own in-table add-row affordance.
    return <ModernDataTable hideTableAddRow />;
  }

  if (toolbarType === 'Property') {
    // Same reasoning as the Data tab above — the toolbar/below-table button
    // already handles adding an indicator.
    return !flags?.builderModeTable ? (
      <BuilderModePropertyTableOpz hideTableAddRow />
    ) : (
      <BuilderModePropertyTableMetadata hideTableAddRow />
    );
  }

  return <MapTab />;
};

export default withLDConsumer()(BuilderModeTable);
